import {
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuText,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuSeparator
} from "@/components/ui/dropdown-menu"
import { ReplyAll, Share, PlusSquare, Trash, Monitor, Moon, Sun, Users, Unlink, CopyPlus, LogIn, LogOut, List } from "lucide-react"
import { observer } from "mobx-react-lite"
import { ColorSquareMenuStore, TOKEN_ColorSquareMenuStore } from "./ColorSquareMenuStore"
import { useResolve } from "@/tsyringe-hooks/useResolve"
import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button"

const ColorSquareMenuView = observer(() => {
    const store = useResolve<ColorSquareMenuStore>(TOKEN_ColorSquareMenuStore);
    const { t } = useTranslation();

    return <DropdownMenuContent align="start">
        {store.canShare && <DropdownMenuItem onClick={store.openShareDialog}>
            <Share />
            <DropdownMenuText>{t('generate_share_link')}</DropdownMenuText>
        </DropdownMenuItem>}
        {store.canShare && <DropdownMenuItem onClick={store.openShareLinksDialog}>
            <Unlink />
            <DropdownMenuText>{t('share_links')}</DropdownMenuText>
        </DropdownMenuItem>}
        <DropdownMenuItem onClick={store.openUsersDialog}>
            <Users />
            <DropdownMenuText>{t('active_users')}</DropdownMenuText>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={store.playHistory}>
            <ReplyAll />
            <DropdownMenuText>{store.playHistoryText}</DropdownMenuText>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={store.deleteProject}>
            <Trash />
            <DropdownMenuText>{t('delete_project')}</DropdownMenuText>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={store.forkProject}>
            <CopyPlus />
            <DropdownMenuText>{t('fork_project')}</DropdownMenuText>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={store.openMyProjectsDialog}>
            <List />
            <DropdownMenuText>{t('my_projects')}</DropdownMenuText>
        </DropdownMenuItem>
        <DropdownMenuSub>
            <DropdownMenuSubTrigger>
                <PlusSquare />
                <DropdownMenuText>{t('create_new_project')}</DropdownMenuText>
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
                <DropdownMenuItem onClick={store.createNewProject16}>
                    <DropdownMenuText>16 x 16</DropdownMenuText>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={store.createNewProject32}>
                    <DropdownMenuText>32 x 32</DropdownMenuText>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={store.createNewProject64}>
                    <DropdownMenuText>64 x 64</DropdownMenuText>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={store.createNewProject128}>
                    <DropdownMenuText>128 x 128</DropdownMenuText>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={store.createNewProject256}>
                    <DropdownMenuText>256 x 256</DropdownMenuText>
                </DropdownMenuItem>
            </DropdownMenuSubContent>
        </DropdownMenuSub>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={store.loginOrLogout}>
            {store.isLoggedIn ? <LogOut /> : <LogIn />}
            <DropdownMenuText>{store.isLoggedIn ? t('user_logout') : t('user_login')}</DropdownMenuText>
        </DropdownMenuItem>
        <DropdownMenuItem className="flex items-center">
            {store.isThemeLight && <Sun />}
            {store.isThemeDark && <Moon />}
            {store.isThemeSystem && <Monitor />}
            <DropdownMenuText>{t('theme')}</DropdownMenuText>
            <div className="flex-1 flex justify-end">
                <Button
                    variant={store.isThemeLight ? "outline" : "ghost"}
                    size="iconsm"
                    onClick={store.setThemeLight}
                    aria-label={t('light_mode')}
                    title={t('light_mode')}
                >
                    <Sun />
                </Button>
                <Button
                    variant={store.isThemeDark ? "outline" : "ghost"}
                    size="iconsm"
                    onClick={store.setThemeDark}
                    aria-label={t('dark_mode')}
                    title={t('dark_mode')}
                >
                    <Moon />
                </Button>
                <Button
                    variant={store.isThemeSystem ? "outline" : "ghost"}
                    size="iconsm"
                    onClick={store.setThemeSystem}
                    aria-label={t('system_mode')}
                    title={t('system_mode')}
                >
                    <Monitor />
                </Button>
            </div>
        </DropdownMenuItem>
    </DropdownMenuContent>
});

export default ColorSquareMenuView;